import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findClassify = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v2/engineer_classify?`+params,
        method: 'GET'
    })
}

export const findClassifyAll = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v2/engineer_classify/select?`+params,
        method: 'GET'
    })
}

export const addClassify = (data) => {
    return request({
        url: `${baseUrl}//joins-product/v2/engineer_classify`,
        method: 'POST',
        data: data
    })
}

export const editClassify = (data) => {
    return request({
        url: `${baseUrl}/joins-product/v2/engineer_classify`,
        method: 'PUT',
        data: data
    })
}

export const delClassify = (ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}//joins-product/v2/engineer_classify/${temp}`,
        method: 'DELETE'
    })
}